/* build/tpl */
import deps from './deps/index.js';
import getIndex from './getIndex.js';
export default getIndex(deps);
